import { IParamsGetUser, IResetPassordUser, IResponseGetUser, IEditUser, IUser } from '~/utils/interface/user';
import axiosClient from './axiosClient';

const url: string = '/api/users';

const userApi = {
  getList(params: IParamsGetUser) {
    return axiosClient.get<IResponseGetUser>(url, { params });
  },

  create(data: IEditUser) {
    return axiosClient.post<IUser>(url, data);
  },

  update(data: IEditUser) {
    return axiosClient.put<IUser>(url, data);
  },

  active(username: string, data: IParamsGetUser) {
    return axiosClient.post<IUser>(`${url}/active/${username}`, data);
  },

  resetPassword(data: IResetPassordUser) {
    return axiosClient.post<IUser>(`${url}/reset-password`, data);
  },

  delete(id: string) {
    return axiosClient.delete<IUser>(`${url}/${id}`);
  },
};
export default userApi;
